import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';
import { PeriodPropTypes } from '../../shared/propTypes/period';
import { requiredWhenPresent } from '../../shared/propTypes';

const DeleteAdminTaxEntryModal = ({
  period,
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
}) => {
  const { name: periodName } = period;

  const removeTaxEntry = useCallback(() => {
    if (entityToRemove) {
      removeEntity({ ...entityToRemove, periodName }, { rowIndex });
    }
  }, [removeEntity, entityToRemove, periodName, rowIndex]);

  return (
    <Modal
      className="delete-admin-tax-entry-list-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Tax Entry"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeTaxEntry}
      isVisible={isVisible}
    >
      {entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            Period: {periodName}<br/>
            Type: {entityToRemove.type}<br/>
            Activity: {entityToRemove.activity}<br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};

DeleteAdminTaxEntryModal.propTypes = {
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
    periodName: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    activity: PropTypes.string.isRequired,
  })),
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
};

export default DeleteAdminTaxEntryModal;
